export default __webpack_public_path__ + "static/media/clarify_text_grey.7759755e.svg";